"use client";

import { notFound, useParams } from "next/navigation";
import useFooterPage from "./_hooks/useFooterPage";
import PageSkeleton from "./skeleton/PageSkeleton";
import InfoPage from "./_components/InfoPage";
import LegalPage from "./_components/LegalPage";
import { useEffect } from "react";

export default function FooterPageRoute() {
    const params = useParams();
    const pageSlug = params?.page_slug;
    const { page, loading } = useFooterPage(pageSlug);
    const contentType = page?.data?.page?.content_type;

    useEffect(() => {
        const siteTitle = process.env.NEXT_PUBLIC_SITE_TITLE || "Belyfted";

        const title = page?.data?.page?.title
            ? page.data.page.title
            : pageSlug
            ? pageSlug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
            : "";

        document.title = title
            ? `${siteTitle} - ${title}`
            : siteTitle;
    }, [page, pageSlug]);

    if (loading) return <PageSkeleton />;
    if (!page) return notFound();

    return contentType === 0 ? (
        <InfoPage page={page} pageSlug={pageSlug} />
    ) : (
        <LegalPage page={page} pageSlug={pageSlug} />
    );
}
